import React, { useEffect, useState } from 'react'
import DonutChart from '../../components/DonutChart'
import TitleLink from '../../components/TitleLink'
import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../../constants';
function ProgramBox() {
  const {t} = useTranslation('global');
  const [programStats, setProgramStats] = useState({});

  useEffect(() => {
    let url = `${BASE_URL}/programStats`;
    fetch(url, {
      method:"GET",
      headers: {
          "authorization": `${localStorage.getItem('token')}` ,
          "Content-Type": "application/json",
      },
    }).then((response)=>{
      return response.json();
    }).then((res)=>{
      setProgramStats(res);
    })

  },[]);
  
  const chartOptions = {
    series: Object.values(programStats),
    options: {
      chart: {
        width: 380,
        type: 'donut',
      },
      labels: ['0% - 33%', '34% - 66%', '67% - 100%'],
      colors:['#028FD7', '#015681', '#001D2B']
    },
  }

  return (
    <div className='half-container-mr'>
        <TitleLink
            enableLink={true}
            boxTitle={t('program_completion')}
            linkTitle={t('view_all')}
            link={'/programs'}
        />
        <DonutChart chartOptions={chartOptions}/>
    </div>
)
}

export default ProgramBox